var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopographicalLinesBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa0be4f0-7014-4931-b563-a97cb1d8633a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1922.54 185.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-1.42,35S6,30.34,47.49,30.75c35.8.35,80.95-11.39,80.95-11.39s33.77-6.92,48.41-7.73c0,0,6.1-2.44,31.73,8.95S275.7,43.76,275.7,43.76s35.39,6.92,57.35,6.92,93.56,2.85,93.56,2.85a116.58,116.58,0,0,1,27.26,4.88c14.64,4.47,84.61,24.4,84.61,24.4s13.83,3.26,23.18,3.26H628s12.61.81,39.45,6.51c0,0,73.22,15,97.63,14.64H810.2s18.72.8,46,11.79,34.58,11.79,34.58,11.79,38.23,5.7,90.3-16.67,79.32-38.65,79.32-38.65,12.21-8.54,15.46-12.2,11.39-9.36,26.85-12.61l62.64-11a101.18,101.18,0,0,1,45.15,4.47c21.8,7.45,54.11,17.49,54.11,17.49s41.49,12.2,86.64,3.66,72.41-14.64,72.41-14.64,28.06-8.14,71.18,5.29,61.83,19.12,61.83,19.12,22,6.1,34.58-.82,15.46-9.35,15.46-9.35,4.84-2.61,32.13-2a88.49,88.49,0,0,0,35.8-7.32s65.9-37.83,122.44-42.31,123-6.1,123-6.1",
    transform: "translate(2.49 -5.15)",
    style: {
      fill: "none",
      stroke: "#6fccdd",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,149s12.92,1.22,29.09-4.88S74.24,124,104.14,124.92s69.56,0,69.56,0,31.73,1.27,57.66,9.81,58.88,11.9,58.88,11.9a913.29,913.29,0,0,0,97-3.66c54-4.89,267.25-7.94,267.25-7.94s19.52-2.13,46.07,6.72,57.35,20.13,57.35,20.13,38.44,11,68.65,10.37,129.66,0,129.66,0a142.23,142.23,0,0,1,38.44,5.16c21.35,5.8,37.22,9.15,37.22,9.15s43.63,8.85,101.59-12.51S1247,132.85,1247,132.85s73.53-25.93,128.44-17.39,94.27,39.66,94.27,39.66,53.7,40,127.53,30.2,128.44-27.76,128.44-27.76l115.93-39.36s55.37-19,78.41-18.61",
    transform: "translate(2.49 -5.15)",
    style: {
      fill: "none",
      stroke: "#6fccdd",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopographicalLinesBlue);
export default __webpack_public_path__ + "static/media/topographical-lines-blue.035a39d518f4b4bcc2f4bf768cd124c8.svg";
export { ForwardRef as ReactComponent };